"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _utils = require("../../utils");
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Row = _interopRequireDefault(require("../layout/Row"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  routes: [],
  segmentDelimiter: '-',
  offset: 0,
  limit: undefined,
  className: '',
  navigate(to) {
    window.location.href = to;
  }
};
function Breadcrumbs(props) {
  var _window;
  const {
    routes,
    names,
    offset,
    limit,
    segmentDelimiter,
    className,
    navigate
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const pathname = (0, _utils.isBrowser)() ? (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname : '';
  const defaultRoutes = (0, _react.useMemo)(() => {
    var _pathname$split;
    return pathname === null || pathname === void 0 || (_pathname$split = pathname.split('/')) === null || _pathname$split === void 0 || (_pathname$split = _pathname$split.filter(segments => (segments === null || segments === void 0 ? void 0 : segments.length) > 0)) === null || _pathname$split === void 0 || (_pathname$split = _pathname$split.slice(offset, limit)) === null || _pathname$split === void 0 ? void 0 : _pathname$split.map(path => {
      var _pathname$split2;
      return {
        path: "".concat(pathname === null || pathname === void 0 || (_pathname$split2 = pathname.split(path)) === null || _pathname$split2 === void 0 ? void 0 : _pathname$split2[0]).concat(path),
        name: (0, _utils.capitalize)((names === null || names === void 0 ? void 0 : names[path]) || (path === null || path === void 0 ? void 0 : path.replace(segmentDelimiter, ' ')))
      };
    });
  }, [pathname, names, offset, limit]);
  const routesToRender = (0, _react.useMemo)(() => (routes === null || routes === void 0 ? void 0 : routes.length) > 0 ? routes : defaultRoutes, [routes, defaultRoutes]);
  const navigateTo = path => {
    if (pathname === path) return;
    navigate(path);
  };
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className
  }, routesToRender === null || routesToRender === void 0 ? void 0 : routesToRender.map(_ref => {
    let {
      path,
      name
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_Row.default, {
      key: path,
      gap: 4,
      onClick: () => navigateTo(path)
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      size: 11,
      lineHeight: 11,
      type: "description",
      children: name,
      styles: cssItemStyles
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "arrow_forward_ios",
      size: 8
    }));
  }));
}
const Container = _styled.default.nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 10px 4px;\n  flex-wrap: wrap;\n"])));
const cssItemStyles = (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  min-height: 15px;\n  align-items: center;\n  display: flex;\n\n  @media screen and (min-width: 768px) {\n    font-size: 13px !important;\n    line-height: 13px !important;\n  }\n"])));
var _default = exports.default = Breadcrumbs;